import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api"; // Assurez-vous que le chemin vers api est correct

const ChangePasswordMobile = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (newPassword !== confirmNewPassword) {
            alert("Les nouveaux mots de passe ne correspondent pas.");
            return;
        }

        try {
            const response = await api.post("/auth/change-password", {
                oldPassword,
                newPassword
            });
            if (response.status === 200) {
                alert("Mot de passe changé avec succès.");
                navigate("/dashboard"); // Redirigez vers la dashboard ou toute autre page appropriée
            }
        } catch (error) {
            alert("Erreur lors du changement de mot de passe : " + error.response.data.message);
        }
    };

    return (
        <div className="p-4">
            <h1 className="text-lg font-bold mb-4">Changer de mot de passe</h1>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="oldPassword" className="block text-sm font-medium text-gray-700">Ancien mot de passe</label>
                    <input
                        type="password"
                        id="oldPassword"
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700">Nouveau mot de passe</label>
                    <input
                        type="password"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="confirmNewPassword" className="block text-sm font-medium text-gray-700">Confirmer le nouveau mot de passe</label>
                    <input
                        type="password"
                        id="confirmNewPassword"
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                        required
                    />
                </div>
                <button type="submit" className="w-full bg-blue-500 text-white p-2 rounded-md">Changer le mot de passe</button>
            </form>
        </div>
    );
};

export default ChangePasswordMobile;
